import { getInitials, hasCJK } from "@/lib/format-name";

interface AvatarProps {
	firstName: string;
	lastName: string;
	/** 直径 (px)。デフォルト 28。 */
	size?: number;
}

/** ユーザーの頭文字を表示する円形アバター。 */
export function Avatar({ firstName, lastName, size = 28 }: AvatarProps) {
	const initials = firstName && lastName ? getInitials(firstName, lastName) : "";
	// 全角は 1em、英大文字は約 0.7em。直径に収まる大きさまで縮める。
	const widthInEm = hasCJK(initials) ? initials.length : initials.length * 0.7;
	return (
		<div
			style={{
				width: size,
				height: size,
				borderRadius: "var(--radius-full)",
				background: "var(--neutral-solid)",
				color: "var(--on-neutral-solid)",
				fontSize: Math.min(11, Math.floor((size - 2) / Math.max(widthInEm, 1))),
				whiteSpace: "nowrap",
				fontWeight: 600,
				display: "grid",
				placeItems: "center",
				flexShrink: 0,
			}}
		>
			{initials}
		</div>
	);
}
